export default __webpack_public_path__ + "static/media/Background_00186.f07b0b56.png";